import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetExpensesByClientQuery } from "../../../services/Reports";
import {
  getExpensesByClientRequest,
  getExpensesByClientFailure,
  getExpensesByClientSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allExpensesByClient,
    isLoading: expensesByClientLoading,
    isError: expensesByClientError,
  } = useGetExpensesByClientQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.expensesByClientPageNo,
    pageSize: state.expensesByClientPageSize,
    fromDate: new Date(state.expensesByClientFromDate).toLocaleDateString(),
    toDate: new Date(state.expensesByClientToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (expensesByClientLoading) {
      dispatch(getExpensesByClientRequest());
    }
    if (expensesByClientError) {
      dispatch(getExpensesByClientFailure(expensesByClientError));
    }
    if (allExpensesByClient) {
      dispatch(
        getExpensesByClientSuccess({
          data: allExpensesByClient.data.expensesByClient[0].data || [],
          totalPages:
            allExpensesByClient.data.expensesByClient[0].metadata[0]?.total ||
            0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allExpensesByClient,
    profileData,
    state.expensesByClientFromDate,
    state.expensesByClientToDate,
    state.expensesByClientPageNo,
    state.expensesByClientPageSize,
  ]);
  return <></>;
};
export default Content;
